import * as gettingStarted from "./gettingStarted";
import * as billing from "./billing";
import * as payments from "./payments";
import * as members from "./members";
import * as events from "./events";
import * as fundraising from "./fundraising";
import * as dashboards from "./dashboards";
import type { ArticleContent, ArticleTile } from "./types";

export const newArticles: Record<string, ArticleContent> = {
  ...gettingStarted.articles,
  ...billing.articles,
  ...payments.articles,
  ...members.articles,
  ...events.articles,
  ...fundraising.articles,
  ...dashboards.articles,
};

export const newArticleTiles: ArticleTile[] = [
  ...gettingStarted.tiles,
  ...billing.tiles,
  ...payments.tiles,
  ...members.tiles,
  ...events.tiles,
  ...fundraising.tiles,
  ...dashboards.tiles,
];

export type { ArticleContent, ArticleTile } from "./types";
